import { useEffect, useMemo, useState } from "react";
import TableFilter from "src/components/TableFilter";
import DateUtils from "src/services/utils/DateUtils";

const FilteringComponent = ({
    onChange
}) => {
    const [tableFilters, setTableFilters] = useState({
        from: null,
        to: null,
        search: null
    });

    const dateUtils = new DateUtils();

    const tableFilterTabs = useMemo(() => {
        return [
            {
                type: 'date',
                name: 'filter-date',
                title: 'Date',
                icon: <i className="ri-calendar-event-line" />,
                defaultValue: {
                    from: tableFilters.from,
                    to: tableFilters.to
                }
            },
            {
                type: 'search_textbox',
                name: 'search',
                title: 'Search',
                icon: <i className="ri-search-2-line" />,
                defaultValue: tableFilters?.search,
                options: {
                    placeholder: 'Search',
                    typingDelay: 750
                },
                displayIndependently: true,
                onFilterChange: (value) => {
                    if (value !== tableFilters.search) {
                        setTableFilters((currentState) => ({ ...currentState, search: value }))
                    }
                }
            }
        ]
    }, [
        tableFilters
    ]);

    const onTableFilterOkButtonClicked = (filters, independentTabsData) => {
        if (filters) {
            const result = {}

            if ('filter-date' in filters) {
                result['from'] = dateUtils.convertDateToDate(
                    new Date(filters['filter-date']?.from),
                    'YYYY-MM-DD 00:00:00'
                )

                result['to'] = dateUtils.convertDateToDate(
                    new Date(filters['filter-date']?.to),
                    'YYYY-MM-DD 23:59:59'
                )
            }

            setTableFilters({
                ...tableFilters,
                ...result
            })
        } else {
            setTableFilters({
                from: null,
                to: null,
                search: independentTabsData?.search
            })
        }
    }

    useEffect(() => {
        onChange && onChange(tableFilters)
    }, [tableFilters]);

    return (
        <TableFilter
            className="me-2"
            defaultActiveTab='filter-date'
            tabs={tableFilterTabs}
            onOkButtonClicked={
                onTableFilterOkButtonClicked
            }
        />
    )
}

export default FilteringComponent;